import { useEffect, useRef } from 'react'

/**
 * Deep links da Central de Pendências (L7 / Q40): "cada ação abre o objeto exato que resolve
 * a pendência". A página de destino lê o parâmetro da URL, marca o objeto com
 * `data-destacado="true"` + {@link SX_DESTAQUE} e rola até ele com este hook.
 *
 * Rola UMA vez por alvo, quando o elemento existe (a lista costuma chegar depois do
 * primeiro render) — recarregar a lista não puxa a tela de volta. `scrollIntoView` é
 * opcional porque o jsdom não o implementa.
 *
 * @param elementId id do elemento destacado; nulo/vazio = nada a fazer
 * @param pronto    a lista/objeto já foi renderizado (ex.: `!carregando`)
 */
export const useRolarAteDestaque = (elementId: string | null | undefined, pronto: boolean): void => {
  const rolado = useRef<string | null>(null)
  useEffect(() => {
    if (!elementId || !pronto || rolado.current === elementId) return
    const el = document.getElementById(elementId)
    if (!el) return
    rolado.current = elementId
    el.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
  })
}

/**
 * Identidade de um item do checklist documental no deep link `?item=` — a mesma do
 * `CentralPendenciasService` (chave; nos itens legados sem chave, o rótulo). Usada pelos dois
 * checklists (Nova Reserva e etapa Documentos da Estruturação) para o id `checklist-item-…`.
 */
export const idItemChecklist = (item: { chave?: string | null; label: string }): string =>
  item.chave ?? item.label

/** Destaque visual do objeto aberto por deep link — o mesmo em todas as páginas de destino. */
export const SX_DESTAQUE = {
  outline: '2px solid',
  outlineColor: 'primary.main',
  outlineOffset: '-2px',
  bgcolor: 'action.selected',
} as const
